import { useEffect, useState } from 'react';
import { PopupSideBarImage } from '../../PopupSidebarImage';
import { LightBox } from '../../../LightBox/LightBox';
import { GetThumbnail } from '../../funcs';
import { Button } from '../../../Button/Button';
import './PopupInspiratie.scss';
export const PopupInspiratie = (props) => {
    return <div className="c-detail-fiche__body">
        <div className="practical">
            <div className="left">
                <div className="inner">
                    <div className="bottom">
                        <PopupInspiratieSideBar dictionary={props.dictionary} blockListSideBarContentHandler={props.blockListSideBarContentHandler} data={props.data} />
                    </div>
                </div>
            </div>
            <div className="right">
                <Button className="c-download-pdf" buttonType={"primary"} label="download" onClick={() => props.printComponentToPdf(props.data.urlSegment)} />
                <PopupInspiratieBody dictionary={props.dictionary} blockListBodyContentHandler={props.blockListBodyContentHandler} data={props.data} />
            </div>
        </div>
    </div>;
}

const PopupInspiratieSideBar = (props) => {
    const [lightboxThumbnailUrl, setLightboxThumbnailUrl] = useState("");

    useEffect(() => {
        (async () => {
            if (props.data.video && props.data.video.url) {
                var thumbnail = await GetThumbnail(props.data.video.url);
                setLightboxThumbnailUrl(thumbnail);
            }
        })()

    }, [JSON.stringify(props.data.video)]);


    const sideBarExtraItems = props.blockListSideBarContentHandler(props.data.detailSideBar.extraFields);
    let sidebarImages = [];
    for (let i = 0; i < props.data.detailSideBar.extraPictures.length; i++) {
        const img = props.data.detailSideBar.extraPictures[i];
        sidebarImages.push(<div className="image">
            <PopupSideBarImage src={img.url} Alt={img.alt} />
        </div>);
    }
    return <div className='bottom'>
            {sideBarExtraItems.length > 0 &&
                <div className="info">
                    {sideBarExtraItems}
                </div>
            }
            {sidebarImages.length > 0 &&
                <div className='sidebarpictures'>
                    {sidebarImages}
                </div>            
            }
            {props.data.video &&
                <div className="video">
                    <LightBox thumbnail={lightboxThumbnailUrl} slides={[props.data.video]} />
                </div>
            }
    </div>;
}

const PopupInspiratieBody = (props) => {
    const contentBlocks = props.blockListBodyContentHandler(props.data.detailBody.content);
    return <div className='inner'>
        {contentBlocks}
    </div>
}